import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const TooltipContainer = styled.div`
  position: fixed;
  z-index: 9999;
  background: #1f2939;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  max-width: 250px;
  white-space: nowrap;
`;

const ChartTooltip = ({ content, position }) => {
  const tooltipRef = useRef(null);
  const [adjustedPosition, setAdjustedPosition] = useState(position);

  useEffect(() => {
    if (!position || !tooltipRef.current) return;

    const tooltipRect = tooltipRef.current.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    let newX = position.x;
    let newY = position.y;

    // Adjust X if tooltip goes off right edge
    if (position.x + tooltipRect.width > windowWidth) {
      newX = position.x - tooltipRect.width - 10; // Position to the left of the cursor
    }

    // Adjust Y if tooltip goes off bottom edge
    if (position.y + tooltipRect.height > windowHeight) {
      newY = position.y - tooltipRect.height - 10;
    }

    setAdjustedPosition({ x: newX, y: newY });
  }, [position]);

  if (!position) return null;

  return (
    <TooltipContainer
      ref={tooltipRef}
      style={{
        left: `${adjustedPosition?.x || position.x}px`,
        top: `${adjustedPosition?.y || position.y}px`,
      }}
    >
      {content}
    </TooltipContainer>
  );
};

export default ChartTooltip;
